import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos'; 
import 'aos/dist/aos.css'; 
import '../styles/stylesInformacion.css';
import EspaciosPublicos from '../componentes/EspaciosPublicos';


const Informacion = () => {
  const { hash } = useLocation();

  const [activeCard, setActiveCard] = useState(null);

  // Función para abrir/cerrar tarjetas
  const toggleCard = (index) => {
    setActiveCard(activeCard === index ? null : index);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });

    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) {
        const isMobile = window.innerWidth < 768;
        const headerOffset = 110;
        const elementPosition = elem.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: isMobile ? 'auto' : 'smooth' 
        });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="InfoMenu">
      
      {/* --- SECCIÓN: CONOCE NUESTRO PUEBLO --- */}
      <section className="conoce-pueblo" id="elPueblo">
        
        {/* 1. HERO (Video + Texto) */}
        <div className="pueblo-hero">
          <div className="pueblo-video-container" data-aos="fade-right">
             <iframe 
                className="pueblo-video-frame"
                src="https://www.youtube.com/embed/fNvRtSzZN_0?modestbranding=1&rel=0" 
                title="Video Institucional" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
             ></iframe>
          </div>
          
          <div className="pueblo-titulo-container" data-aos="fade-left">
             <div className="titulo-content">
                <h2>Descubrí nuestra identidad</h2>
                <div className="pueblo-titulo-linea"></div>
                <p className="pueblo-descripcion-hero">
                  Santo Domingo es mucho más que un punto en el mapa. Es el resultado del esfuerzo de generaciones, la calidez de su gente y la fuerza de un sector productivo que no se detiene. Te invitamos a conocer nuestra historia y nuestro futuro.
                </p>
             </div>
          </div>
        </div>

        {/* 2. TARJETAS EXPANDIBLES */}
        <div className="cards-expandibles-container">
          
          {/* TARJETA 1: HISTORIA */}
          <div 
            className={`card-expandible ${activeCard === 0 ? 'active' : ''}`} 
            onClick={() => toggleCard(0)}
          >
            <div className="card-visible">
              <h3>Nuestra Historia</h3>
              <span className="icon-indicator">{activeCard === 0 ? '−' : '+'}</span>
            </div>
            <div className="card-hidden">
               <p>A mediados del siglo pasado, Don Ignacio Crespo envía una carta al Gobernador de la Provincia Dr. Juan Manuel Cafferata; en la misma manifiesta su deseo de formar la Colonia y Pueblo de Santo Domingo; en terrenos de su propiedad.</p>
               <p>El 21 de septiembre de 1891, el Gobernador da conformidad para que se realice dicha fundación.</p>
               <p>La Colonia y Pueblo de Santo Domingo se fundan el 14 de Octubre de 1891 por Ignacio Crespo, quien le dio el nombre en honor al Santo de su devoción: Santo Domingo de Guzmán.</p>
               <p>La Colonia, es trazada en su origen limitando al norte con la Colonia María Luisa, al sur con campos de los hermanos Crespo, al este con la Estancia “Sarita” y al oeste con el Arroyo Cululú.</p>
               <p>En el año 1893, Ignacio Crespo presenta al señor gobernador un petitorio para poder ensanchar la Colonia Santo Domingo, petición que fue aprobada incrementando la superficie a 92.790.000 metros cuadrados.</p>
               <p>La Estancia Sarita, se extendía desde el límite este de la Colonia Santo Domingo hasta el Río Salado. Entre los años 1920 y 1921 el establecimiento fue loteado y vendido. Se unificaron los nombres en 1971 dando origen al nombre actual “Santo Domingo”.</p>
               <p>El 16 de marzo de 1903, el entonces Gobernador de Santa Fe, Don Rodolfo Freyre, crea por decreto la primera Comisión de Fomento.</p>
            </div>
          </div>

          {/* TARJETA 2: PERFIL PRODUCTIVO */}
          <div 
            className={`card-expandible ${activeCard === 1 ? 'active' : ''}`} 
            onClick={() => toggleCard(1)}
          >
            <div className="card-visible">
              <h3>Perfil Productivo</h3>
              <span className="icon-indicator">{activeCard === 1 ? '−' : '+'}</span>
            </div>
            <div className="card-hidden">
               <p>La actividad principal es agrícola‑ganadera, con altos rindes y producción de ganado vacuno. La lechería abastece a grandes industrias regionales. Existen producciones porcinas, una fábrica láctea en la ex estación de trenes y una zona fabril en desarrollo sobre la Ruta Provincial N.º 4.</p>
               <p>En la zona urbana se desarrollan pymes dedicadas a elaboración y venta de alimentos, maderas, metalurgia, alimentos balanceados, calzado, aberturas, comercios y servicios tercerizados.</p>
            </div>
          </div>

          {/* TARJETA 3: UBICACIÓN */}
          <div 
            className={`card-expandible ${activeCard === 2 ? 'active' : ''}`} 
            onClick={() => toggleCard(2)}
          >
            <div className="card-visible">
              <h3>Ubicación Geográfica</h3>
              <span className="icon-indicator">{activeCard === 2 ? '−' : '+'}</span>
            </div>
            <div className="card-hidden">
               <p>La localidad de Santo Domingo está situada en el centro norte del Departamento Las Colonias; a 80 km de Santa Fe Capital, llegando por la Ruta Provincial N.º 4 y la Ruta 301‑S. Su territorio se encuentra entre el Río Salado al este y el Arroyo Cululú al oeste.</p>
               <p>A través de la Ruta Provincial N.º 4 se conecta al norte con San Cristóbal y al sur con Esperanza y Santa Fe. Se caracteriza por la fertilidad de sus tierras y la proximidad a centros urbanos de gran actividad económica.</p>
               <p>El distrito ocupa 166 km² y, según el censo 2010, cuenta con 1.742 habitantes.</p>
            </div>
          </div>

        </div>

        {/* 3. SÍMBOLOS (BANDERA Y ESCUDO) */}
        <div className="simbolos-patrios" data-aos="fade-up">
           <div className="simbolo-item">
              <div className="media-wrapper">
                 <video 
                    src="/resources/bandera.mp4" 
                    autoPlay loop muted playsInline
                    className="simbolo-video-element"
                 />
              </div>
              <h4>Nuestra Bandera</h4>
           </div>
           
           <div className="simbolo-item">
              <div className="media-wrapper">
                 <img 
                    src="/resources/logo comuna.png" 
                    alt="Escudo Santo Domingo" 
                    className="simbolo-img-element"
                    onError={(e) => e.target.src = '/resources/logoVector.png'} 
                 />
              </div>
              <h4>Nuestro Escudo</h4>
           </div>
        </div>

      </section>

      {/* --- SECCIÓN: ESPACIOS PÚBLICOS --- */}
      <section className="espaciosPublicos" id="espaciosPublicos">
        <EspaciosPublicos />
      </section>

      {/* --- SECCIÓN: DATOS ÚTILES --- */}
      <section className="datosUtiles" id="datosUtiles">
        <div className="datosUtiles__wrap">
          <h2 className="datosUtiles__title">Teléfonos útiles</h2>

          {(() => {
            const phoneGroups = [
              {
                title: "Comuna de Santo Domingo",
                items: [
                  { label: "Recepción Central", phones: ["03497-498011", "03497-498134", "3497-401754"] },
                  { label: "Agua potable", phones: ["3497-400809"] },
                  { label: "Radio Comunal", phones: ["03497-498222", "3497-400810"] },
                  { label: "Correo – IAPOS", phones: ["03497-498011", "3497-401754"] }
                ]
              },
              {
                title: "SAMCo",
                subtitle: "Ex - Hospital Rural Nº 24",
                items: [
                  { label: "Urgencias / Administración", phones: ["03497-498065", "3497-406888"] }
                ]
              },
              {
                title: "Seguridad y Justicia",
                items: [
                  { label: "Subcomisaría Octava", phones: ["03497-498071"] },
                  { label: "Juzgado de Paz", phones: ["03497-498073"] }
                ]
              },
              {
                title: "Banco",
                items: [{ label: "Nuevo Banco de Santa Fe", phones: ["03497-498072"] }]
              },
              {
                title: "Cultura",
                items: [
                  { label: "Biblioteca Popular “DF Sarmiento”", phones: ["03497-498213"], email: "bibliosantodomingo@gmail.com" },
                  { label: "Museo Comunal “Santo Domingo y Sarita”", phones: ["3497-415857", "3497-483780"] }
                ]
              },
              {
                title: "Educación",
                items: [
                  { label: "Inst. Educativo (Esc. Agrotécnica / ISPI)", phones: ["03497-498074"] },
                  { label: "Escuela Primaria Nº349 “José de San Martín”", phones: ["03497-498300"] },
                  { label: "Jardín de Infantes Nº160 “Rosa de Sraier”", phones: ["03497-498174"] }
                ]
              },
              {
                title: "Acción social",
                items: [
                  { label: "Centro de Día “El Jacarandá”", phones: ["03497-498609"] },
                  { label: "Hogar de Ancianos “8 de Agosto”", phones: ["3497-535280"], email: "hogarcoop08@gmail.com", note: "Ref: Mariela Rosa" }
                ]
              },
              {
                title: "Clubes",
                items: [
                  { label: "FC Juventud Unida", phones: ["3497-404468"], email: "faniterzagui@hotmail.com", note: "Ref: Estefanía Terzaghi" },
                  { label: "CCRyD Unión", phones: ["3497-659138"], note: "Ref: Luis Lazzaroni" }
                ]
              },
              {
                title: "Iglesias",
                items: [
                  { label: "Iglesia Evangélica del Río de La Plata", phones: ["3496-524162"], note: "Pastora Marisa Hunzicker" },
                  { label: "Iglesia Católica Santo Domingo de Guzmán", phones: ["342-5396444"], note: "Sacerdote Ricardo Collombo" },
                  { label: "Templo Visión de Futuro", phones: ["3497-401174"], note: "Pastor Omar Platner" }
                ]
              },
              {
                title: "Adultos mayores",
                items: [{ label: "Centro de Jubilados y Pensionados", phones: ["3497-481859"], note: "Ref: Viviana Zeballos" }]
              }
            ];

            return (
              <div className="datosUtiles__grid">
                {phoneGroups.map((group, idx) => (
                  <div key={idx} className="datosUtiles__card">
                    <div className="datosUtiles__cardHeader">
                      <h3 className="datosUtiles__cardTitle">{group.title}</h3>
                      {group.subtitle && <span className="datosUtiles__cardSubtitle">{group.subtitle}</span>}
                    </div>

                    <div className="datosUtiles__cardBody">
                      {group.items.map((item, iIdx) => (
                        <div key={iIdx} className="datosUtiles__item">
                          <p className="datosUtiles__label">{item.label}</p>
                          
                          <div className="datosUtiles__numbers">
                            {item.phones.map((phone, pIdx) => (
                              <div key={pIdx} className="datosUtiles__numberRow">
                                <a href={`tel:${phone.replace(/-/g, '')}`} className="datosUtiles__phoneLink">
                                  {phone}
                                </a>
                                <a href={`tel:${phone.replace(/-/g, '')}`} className="datosUtiles__callBtn">
                                  Llamar
                                </a>
                              </div>
                            ))}
                          </div>

                          {item.email && (
                            <p className="datosUtiles__meta">
                              <a href={`mailto:${item.email}`}>{item.email}</a>
                            </p>
                          )}
                          {item.note && (
                            <p className="datosUtiles__meta">
                              <span>{item.note}</span>
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      </section>

      {/* --- SECCIÓN: PLANO --- */}
      <section className="plano" id="plano">
        {/* Título unificado */}
        <h2 className='tituloPlano'>Plano</h2>
        <div className='contenedorPlano'>
          <img src="/resources/plano.jpg" alt="plano" />
        </div>
        <p className="planoFuente">
          Encontralo en: <a className="planoLink" href="https://www.santafe.gov.ar/ipecinformes/uploads/planta/SANTODOMINGO_A2H.pdf" target="_blank" rel="noreferrer">SANTODOMINGO_A2H.pdf</a>
        </p>
      </section>
    </div>
  );
};

export default Informacion;